import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const clientTypeList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.get('/unit-client-type/list', {
        pageSize: state.pageSize,
        pageNumber: state.pageNumber,
        ...query,
      }),
    { pageSize, pageNumber },
  );
};

export const clientTypeParentList = (params) => {
  return _baseClient.get('/unit-client-type/parent-list', params);
};

export const clientTypeAdd = (params) => {
  return _baseClient.post('/unit-client-type/save', { body: params }).then((response) => {
    return response;
  });
};

export const clientTypeDelete = (params) => {
  return _baseClient.get('/unit-client-type/delete', params);
};

export const clientTypeDetail = (params) => {
  return _baseClient.get('/unit-client-type/get', params);
};

export const clientTypeUpdateStatus = (params) => {
  return _baseClient.get('/unit-client-type/update-status', params);
};
